import { BillingKeyPaymentInfoType, OrderType } from '@kinderlabs-pos/shared-data-type';
import { OrderState, PaymentState } from '@kinderlabs-pos/state';
import { WithDialog, XlDialogProps } from '@kinderlabs-pos/ui-atoms';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { BillingKeyDialogContent } from './BillingKeyDialogContent';

export type HandleSubmitBillingKeyPaymentArgsType = {
	method: 'VAUNCE_APP_BILLING';
	amount: number;
	ddiziId: string;
	billKey: string;
	goodsName: string;
	memberId: number;
};

export interface IBillingKeyDialogProps extends XlDialogProps {
	mode: OrderType['type'];
	handleSubmitPayment: (args: BillingKeyPaymentInfoType) => Promise<void>;
	storeId: number;
	posId: number;
	// orderId?: OrderType['id'];
}
export const BillingKeyDialog = ({
	storeId,
	posId,
	// orderId,
	mode,
	open,
	closeDialog,
	handleSubmitPayment,
}: // submitPointPayment,
IBillingKeyDialogProps) => {
	const orderState = useAtomValue(OrderState.value);
	const handleSubmitPaymentPM = PaymentState.actions.submit.useHandlePaymentPM({
		storeId,
		posId,
		// orderId,
	});

	const handleSubmitPointPayment = useCallback(
		async (args: HandleSubmitBillingKeyPaymentArgsType) => {
			const paymentRequestData = await handleSubmitPaymentPM(
				{
					method: args.method,
					goodsName: args.goodsName,
					// storeVisitId: args.storeVisitId,
					ddiziId: args.ddiziId,
					billKey: args.billKey,
					amount: args.amount,
					memberId: args.memberId,
				},
				orderState
			);

			await handleSubmitPayment(paymentRequestData as BillingKeyPaymentInfoType);
		},
		[handleSubmitPayment]
	);

	return (
		<WithDialog.XlDialog
			dialogTitle={'바운스앱 결제'}
			open={open}
			closeDialog={closeDialog}>
			<BillingKeyDialogContent
				submitPayment={handleSubmitPointPayment}
				closeDialog={closeDialog}
				goodsName={(() => {
					const filteredLines = orderState.cart.lines.filter((l) => !l.targetCartLineId);
					if (filteredLines.length === 0) return '';
					if (filteredLines.length === 1) {
						const line = filteredLines[0];
						return `${line.name} x${line.quantity}`;
					}
					return `${filteredLines[0].name} x${filteredLines[0].quantity} 외 ${
						filteredLines.length - 1
					}건`;
				})()}
			/>
		</WithDialog.XlDialog>
	);
};
